<!-- 标准专业列表 -->
<template>
  <div class="major_tree">
    <ul class="left_tree">
      <li v-for="(item, index) in speclist" :key="index" :class="[item.specId === activeIndex ? 'active' : '']"
        @click="detailBtn(item)">
        <img :src="icon" alt="" />
        <span :title="item.specName">{{ item.specName }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import standardTemplateService from "@/CommonDP/service/standardTemplate-service";
import { mapState } from "vuex";
export default {
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      speclist: [],
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      activeIndex: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  created() {
    this.getSpecList();
  },
  methods: {
    async getSpecList() {
      if (this.type === 1) {
        const res = await standardTemplateService.getSpecTree(this.enterpriseId);
        this.speclist = res.data;
        if (res.data && res.data.length > 0) {
          this.speclist.forEach(ele => {
            ele.specId = ele.id;
            ele.specName = ele.name;
          });
          this.activeIndex = res.data[0].specId;
          this.$emit("detailBtn", res.data[0]);
        }
      } else {
        const res = await standardTemplateService.getSpecListStandard(this.enterpriseId);
        this.speclist = res.data;
        if (res.data && res.data.length > 0) {
          this.activeIndex = res.data[0].specId;
          this.$emit("detailBtn", res.data[0]);
        }
      }
    },
    detailBtn(val) {
      this.activeIndex = val.specId;
      this.$emit("detailBtn", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.major_tree {
  .left_tree {
    overflow: auto;
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 10px;
    right: 0;
    li {
      display: flex;
      border-bottom: 0;
      align-items: center;
      padding: 2px 10px;
      cursor: pointer;
      font-size: 14px;
      line-height: 26px;
      color: var(--key-color);
      span{
        font-size: 14px;
        overflow: hidden;
        white-space:nowrap;
        text-overflow: ellipsis;
      }
      img {
        margin-right: 8px;
      }
    }
    .active {
      background: rgba(85, 132, 255, 0.1);
    }
  }
}
</style>
